import { Box, Button, Code, CopyIcon, Flex, Tooltip, useClipboard, useDisclosure } from '@chaine/keychaine'
import React from 'react'

import { APIKey } from './developer-page'
interface APIKeyColumnProps {
  apiKey: APIKey
}

export const APIKeyColumn = (props: APIKeyColumnProps) => {
  const { apiKey } = props
  const [value] = React.useState(apiKey.apiKey)
  const { hasCopied, onCopy } = useClipboard(value)
  const { isOpen, onOpen, onClose } = useDisclosure()

  return !isOpen ? (
    <Button size="sm" onClick={onOpen}>
      Reveal key
    </Button>
  ) : (
    <Flex flexDirection="column" alignItems="flex-start" position="relative">
      <Tooltip label="Copied" placement="top" isOpen={hasCopied}>
        <button onClick={onCopy}>
          <Code wordBreak="break-all">{apiKey.apiKey}</Code>
          <Box pl={3}>
            <CopyIcon />
          </Box>
        </button>
      </Tooltip>

      <Button mt="0.5rem" size="sm" onClick={onClose}>
        Hide key
      </Button>
    </Flex>
  )
}
